import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-432c721e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-left font-bold text-[18px] text-black" }, "Lista de escalas", -1))
const _hoisted_3 = { class: "flex w-full" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex flex-col justify-start text-left font-normal" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-xs" }, "Empresa:", -1))
const _hoisted_7 = { class: "text-primary font-bold" }
const _hoisted_8 = { class: "flex gap-1" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex flex-col text-left" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-xs" }, "Unidade:", -1))
const _hoisted_12 = { class: "capitalize" }
const _hoisted_13 = { class: "flex gap-1" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex flex-col text-left" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-xs" }, "Escala:", -1))
const _hoisted_17 = { class: "capitalize flex items-center gap-1" }
const _hoisted_18 = { class: "flex flex-wrap md:gap-2 items-center text-gray-500 text-sm" }
const _hoisted_19 = { class: "flex gap-1 justify-center items-center" }
const _hoisted_20 = {
  key: 4,
  class: "flex gap-1"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex flex-col text-left" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-xs" }, "Turno:", -1))
const _hoisted_24 = { class: "capitalize" }
const _hoisted_25 = { class: "flex gap-1 justify-center items-center" }
const _hoisted_26 = {
  key: 0,
  class: "flex gap-1"
}
const _hoisted_27 = { class: "flex flex-col text-left" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-xs" }, "Posição:", -1))
const _hoisted_29 = { class: "capitalize" }
const _hoisted_30 = { class: "flex gap-1 justify-center items-center" }
const _hoisted_31 = {
  key: 0,
  class: "text-center py-8 text-gray-500"
}

import ArrowIcon from '@/assets/icons/down.vue'
import EditIcon from '@/assets/icons/edit.vue'
import DeleteIcon from '@/assets/icons/delete.vue'
import ListSchedulesSkeleton from '@/components/designSystem/Skeleton/ListSchedulesSkeleton.vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import Network from '@/Network'
import { mdiShareVariantOutline, mdiAccountEye } from '@mdi/js'
import { ref, computed, watch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { timezones } from '@/hooks/useCommon'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import ShareModal from '@/components/designSystem/modals/share.modal.vue'
import ResourcePoliciesModal from '@/components/designSystem/modals/ResourcePoliciesModal/index.vue'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { mdiClipboardTextOutline, mdiSort } from '@mdi/js'
import SortScalesModal, { UnitData } from './modals/SortScalesModal.vue'
import { SimpleHealthUnitResponse } from '@/Network/Types/Responses/HealthUnitResponses'
import {
  ListScheduleItem,
  ListUnitScheduleItem
} from '@/Network/Types/Responses/ScheduleUnitResponses'
import HealthUnitScheduleVisibilityModal from './modals/health.unit.schedule.visibility.modal.vue'
import {
  AuthorizationPermissionCheck,
  AuthorizationResourcesAndSubjects
} from '@/types/authorization'


export default /*#__PURE__*/_defineComponent({
  __name: 'ListSchedules',
  emits: [
  'removeSchedule',
  'updateSchedule',
  'showPositions',
  'showCompanyPolicies',
  'showHealthUnitPolicies',
  'showPositionPolicies',
  'removePosition',
  'updatePosition'
],
  setup(__props, { emit }) {



const modalStore = useModalStore()
const showCompanies = ref<Record<string, boolean>>({})
const showHealthUnits = ref<Record<string, boolean>>({})
const showShifts = ref<Record<number, boolean>>({})
const showPositions = ref<Record<number, boolean>>({})
const { schedulesForPage, isLoadingSchedulesForPage } = storeToRefs(useScheduleStore())

const searchTerm = ref('')

const policyAlertSet = ref<Set<number>>(new Set())
const expiredScheduleSet = ref<Set<number>>(new Set())

function sortedSchedules(schedules: (ListScheduleItem & { timezone: string })[]) {
  return [...schedules].sort((a, b) => {
    const aExpired = expiredScheduleSet.value.has(a.id) ? 1 : 0
    const bExpired = expiredScheduleSet.value.has(b.id) ? 1 : 0
    if (aExpired !== bExpired) return aExpired - bExpired
    return a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
  })
}

async function fetchPolicyVigencyStatus() {
  try {
    const { invalidPolicies, expiredSchedules } = await Network.schedule.getPolicyVigencyStatus()
    policyAlertSet.value = new Set(invalidPolicies)
    expiredScheduleSet.value = new Set(expiredSchedules)
  } catch (error) {
    // fallback intencional: os selos de política são decoração da linha da escala.
    // Um toast/estado de erro aqui bloquearia a listagem — que carrega por conta
    // própria e tem estado de erro próprio (`loadError` de useScheduleStore) —
    // por causa de um indicador auxiliar. Sem os selos, a lista segue utilizável.
    console.error('Falha ao verificar a vigência das políticas das escalas:', error)
    policyAlertSet.value = new Set()
    expiredScheduleSet.value = new Set()
  }
}

onMounted(() => {
  if (!isLoadingSchedulesForPage.value && schedulesForPage.value.length > 0) {
    fetchPolicyVigencyStatus()
  }
})

watch(isLoadingSchedulesForPage, (isLoading, wasLoading) => {
  if (wasLoading && !isLoading && schedulesForPage.value.length > 0) {
    fetchPolicyVigencyStatus()
  }
})

watch(
  [
    () => modalStore.modals[EModals.EDIT_SCHEDULE],
    () => modalStore.modals[EModals.RESOURCE_POLICIES_MODAL]
  ],
  ([editOpen, resourcePoliciesOpen], [wasEditOpen, wasResourcePoliciesOpen]) => {
    if ((wasEditOpen && !editOpen) || (wasResourcePoliciesOpen && !resourcePoliciesOpen)) {
      fetchPolicyVigencyStatus()
    }
  }
)

const toggleScheduleVisibilityModal = ref(false)
const healthUnitToUpdate = ref<SimpleHealthUnitResponse>()
const policiesTarget = ref<{
  type: AuthorizationResourcesAndSubjects
  id: number
  name: string
  companyId: number
} | null>(null)

const permissionsStore = usePermissionsStore()

const check = (permission: string, type: string, id: string | number) => {
  const checkObject: AuthorizationPermissionCheck = {
    permission: permission as any,
    resource: { objectType: type as any, objectId: Number(id) }
  }
  return permissionsStore.check(checkObject)
}

const checkAny = (permission: string, type: string) => {
  return permissionsStore.checkAnyRessources({
    permission: permission as any,
    resourceType: type as any
  })
}

const canReadSchedulePolicies = checkAny('schedule_payment_policies_links_reading', 'schedule')
const canReadSharingModal = checkAny('sharing_modal_reading_grant_access', 'company')
const canReorderHealthUnit = checkAny('health_unit_reordering', 'health_unit')
const canEditSchedule = checkAny('schedule_editing', 'schedule')
const canDeactivateSchedule = checkAny('schedule_deactivating', 'schedule')
const canEditSchedulePosition = checkAny('schedule_position_editing', 'schedule')
const canDeactivateSchedulePosition = checkAny('schedule_position_deactivating', 'schedule')

const canReadSchedule = (id: number) => check('schedule_basic_reading', 'schedule', id)

const shouldShowHealthUnit = (healthUnit: any) => {
  const hasUnitPermission = check('health_unit_basic_reading', 'health_unit', healthUnit.id)

  if (hasUnitPermission) return true

  return healthUnit.schedules.some((schedule: any) =>
    check('schedule_basic_reading', 'schedule', schedule.id)
  )
}

const normalize = (text: string) =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

const isSearchActive = computed(() => normalize(searchTerm.value).length > 0)

function notNull<T>(value: T | null): value is T {
  return value !== null
}

const filteredSchedules = computed(() => {
  const term = normalize(searchTerm.value)
  if (!term) return schedulesForPage.value

  return schedulesForPage.value
    .map((company) => {
      const companyMatch = normalize(company.name).includes(term)

      const filteredUnits = company.units
        .filter((unit) => shouldShowHealthUnit(unit))
        .map((unit) => {
          const unitMatch = normalize(unit.name).includes(term)

          const filteredUnitSchedules = unit.schedules
            .filter((s) => canReadSchedule(s.id))
            .map((schedule) => {
              const scheduleMatch = normalize(schedule.name).includes(term)

              const filteredShifts = schedule.shifts
                .map((shift) => {
                  const shiftMatch = normalize(shift.name).includes(term)
                  const filteredPositions = shift.positions.filter((pos) =>
                    normalize(pos.name).includes(term)
                  )

                  if (shiftMatch || filteredPositions.length > 0) {
                    return { ...shift, positions: shiftMatch ? shift.positions : filteredPositions }
                  }
                  return null
                })
                .filter(notNull)

              if (companyMatch || unitMatch || scheduleMatch || filteredShifts.length > 0) {
                return {
                  ...schedule,
                  shifts:
                    companyMatch || unitMatch || scheduleMatch ? schedule.shifts : filteredShifts
                }
              }
              return null
            })
            .filter(notNull)

          if (companyMatch || unitMatch || filteredUnitSchedules.length > 0) {
            return {
              ...unit,
              schedules: companyMatch || unitMatch ? unit.schedules : filteredUnitSchedules
            }
          }
          return null
        })
        .filter(notNull)

      if (companyMatch || filteredUnits.length > 0) {
        return { ...company, units: companyMatch ? company.units : filteredUnits }
      }
      return null
    })
    .filter(notNull)
})

let searchDebounceTimer: ReturnType<typeof setTimeout>

watch(searchTerm, (val) => {
  clearTimeout(searchDebounceTimer)
  searchDebounceTimer = setTimeout(() => {
    if (!normalize(val)) {
      showCompanies.value = {}
      showHealthUnits.value = {}
      showShifts.value = {}
      showPositions.value = {}
      return
    }

    const companies: Record<string, boolean> = {}
    const units: Record<string, boolean> = {}
    const shifts: Record<number, boolean> = {}
    const positions: Record<number, boolean> = {}

    for (const company of filteredSchedules.value) {
      companies[company.id] = true
      for (const unit of company.units) {
        units[unit.id] = true
        for (const schedule of unit.schedules) {
          shifts[schedule.id] = true
          for (const shift of schedule.shifts) {
            positions[shift.id] = true
          }
        }
      }
    }

    showCompanies.value = companies
    showHealthUnits.value = units
    showShifts.value = shifts
    showPositions.value = positions
  }, 300)
})

const showModalSortScales = ref(false)
const healthUnitSelected = ref<UnitData | null>(null)

const handleOpenSortScalesModal = (healthUnit: ListUnitScheduleItem) => {
  const formattedUnitData: UnitData = {
    id: healthUnit.id,
    name: healthUnit.name,
    schedules: healthUnit.schedules.map((schedule) => ({
      id: schedule.id,
      name: schedule.name,
      shifts: schedule.shifts.map((shift) => ({
        id: shift.id,
        name: shift.name,
        positions: shift.positions || []
      }))
    }))
  }

  healthUnitSelected.value = formattedUnitData
  showModalSortScales.value = true
}

const toggleCompanies = (id: number) => {
  showCompanies.value = { ...showCompanies.value, [id]: !showCompanies.value[id] }
}

const toggleHealthUnits = (id: number) => {
  showHealthUnits.value = { ...showHealthUnits.value, [id]: !showHealthUnits.value[id] }
}

const toggleShifts = (scheduleId: number) => {
  showShifts.value = { ...showShifts.value, [scheduleId]: !showShifts.value[scheduleId] }
}

const togglePositions = (shiftId: number) => {
  showPositions.value = { ...showPositions.value, [shiftId]: !showPositions.value[shiftId] }
}

const getTimezoneDetails = (time: string) => {
  return timezones.find((t) => t.value === time)
}

const handleRemove = (id: number, name: string) => {
  emit('removeSchedule', { id, name })
  modalStore.toggleModal(EModals.REMOVE_SCHEDULE)
}

const handleUpdate = (scheduleDetails: object) => {
  emit('updateSchedule', scheduleDetails)
  modalStore.toggleModal(EModals.EDIT_SCHEDULE)
}

const handleUpdatePosition = (positionId: number, scheduleId: number) => {
  emit('updatePosition', { scheduleId: scheduleId, positionId: positionId })
  modalStore.toggleModal(EModals.UPDATE_POSITION)
}

const handleRemovePosition = (id: number) => {
  emit('removePosition', id)
  modalStore.toggleModal(EModals.REMOVE_POSITION)
}

const openShareModal = (
  resourceName: string,
  resourceType: AuthorizationResourcesAndSubjects,
  resourceId: string | number,
  companyId?: number,
  breadcrumb: string[] = []
) => {
  const resolvedCompanyId =
    companyId ??
    (resourceType === AuthorizationResourcesAndSubjects.Company ? Number(resourceId) : undefined)

  modalStore.metadata = {
    resourceName: resourceName,
    resourceType: resourceType,
    resourceId: +resourceId,
    companyId: resolvedCompanyId,
    breadcrumb: breadcrumb
  }
  modalStore.toggleModal(EModals.SHARE)
}

const showCompanyPolicies = (companyId: number, companyName: string) => {
  emit('showCompanyPolicies', companyId)
  policiesTarget.value = {
    type: AuthorizationResourcesAndSubjects.Company,
    id: companyId,
    name: companyName,
    companyId: companyId
  }
  modalStore.toggleModal(EModals.RESOURCE_POLICIES_MODAL)
}

const showHealthUnitPolicies = (
  companyId: number,
  healthUnitId: number,
  healthUnitName: string
) => {
  emit('showHealthUnitPolicies', healthUnitId)
  policiesTarget.value = {
    type: AuthorizationResourcesAndSubjects.HealthUnit,
    id: healthUnitId,
    name: healthUnitName,
    companyId: companyId
  }
  modalStore.toggleModal(EModals.RESOURCE_POLICIES_MODAL)
}

const showPositionPolicies = (companyId: number, positionId: number, positionName: string) => {
  emit('showPositionPolicies', positionId)
  policiesTarget.value = {
    type: AuthorizationResourcesAndSubjects.Position,
    id: positionId,
    name: positionName,
    companyId: companyId
  }
  modalStore.toggleModal(EModals.RESOURCE_POLICIES_MODAL)
}

function requestChangeSchedulesVisibility(healthUnit) {
  healthUnitToUpdate.value = healthUnit
  toggleScheduleVisibilityModal.value = true
}

const closeScheduleVisibilityModal = async () => {
  toggleScheduleVisibilityModal.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(SearchInput, {
      modelValue: searchTerm.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
      width: "100%",
      label: "Buscar empresa, unidade, escala, turno ou posição",
      "hide-details": ""
    }, null, 8, ["modelValue"]),
    (_unref(isLoadingSchedulesForPage))
      ? (_openBlock(), _createBlock(ListSchedulesSkeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSchedules.value, (company) => {
            return (_openBlock(), _createElementBlock("div", {
              key: company.id,
              class: "flex w-full flex-col"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", {
                  onClick: ($event: any) => (toggleCompanies(company.id)),
                  class: _normalizeClass(["header-title", showCompanies.value[company.id] ? 'rounded-b-none bg-gray-200' : ''])
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("span", _hoisted_7, _toDisplayString(company.name.toLocaleLowerCase()), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (_unref(canReadSchedulePolicies))
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          "data-testid": "company-policies-button",
                          icon: _unref(mdiClipboardTextOutline),
                          onClick: _withModifiers(($event: any) => (showCompanyPolicies(company.id, company.name)), ["stop"])
                        }, null, 8, ["icon", "onClick"]))
                      : _createCommentVNode("", true),
                    (_unref(canReadSharingModal))
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          class: "share-icon hover:cursor-pointer",
                          color: "#52526F",
                          icon: _unref(mdiShareVariantOutline),
                          onClick: _withModifiers(($event: any) => (
                  openShareModal(
                    company.name,
                    _unref(AuthorizationResourcesAndSubjects).Company,
                    company.id,
                    company.id,
                    [company.name]
                  )
                ), ["stop"])
                        }, null, 8, ["icon", "onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(ArrowIcon, {
                      class: _normalizeClass(showCompanies.value[company.id] ? 'rotate-180' : ''),
                      color: "#000"
                    }, null, 8, ["class"])
                  ])
                ], 10, _hoisted_4)
              ]),
              (showCompanies.value[company.id])
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(company.units, (healthUnit) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: healthUnit.id
                    }, [
                      (shouldShowHealthUnit(healthUnit))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["card", showHealthUnits.value[healthUnit.id] ? 'rounded-b-none bg-gray-100' : '']),
                            onClick: ($event: any) => (toggleHealthUnits(healthUnit.id))
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _hoisted_11,
                              _createElementVNode("span", _hoisted_12, _toDisplayString(healthUnit.name.toLocaleLowerCase()), 1)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_v_tooltip, {
                                text: "Reordenar",
                                location: "top"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  (_unref(canReorderHealthUnit))
                                    ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, props, {
                                        icon: _unref(mdiSort),
                                        onClick: _withModifiers(($event: any) => (handleOpenSortScalesModal(healthUnit)), ["stop"])
                                      }), null, 16, ["icon", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_tooltip, {
                                text: "Políticas",
                                location: "top"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  (_unref(canReadSchedulePolicies))
                                    ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, props, {
                                        "data-testid": "health-unit-policies-button",
                                        icon: _unref(mdiClipboardTextOutline),
                                        onClick: _withModifiers(($event: any) => (
                        showHealthUnitPolicies(company.id, healthUnit.id, healthUnit.name)
                      ), ["stop"])
                                      }), null, 16, ["icon", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_tooltip, {
                                text: "Visibilidade para equipe médica",
                                location: "top"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps({
                                    class: "col-span-1 sm:col-span-1 flex items-center justify-end mt-0 mr-3",
                                    size: "22"
                                  }, props, {
                                    onClick: _withModifiers(($event: any) => (requestChangeSchedulesVisibility(healthUnit)), ["stop"]),
                                    icon: _unref(mdiAccountEye)
                                  }), null, 16, ["onClick", "icon"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_tooltip, {
                                text: "Compartilhar",
                                location: "top"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  (_unref(canReadSharingModal))
                                    ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, props, {
                                        class: "share-icon hover:cursor-pointer",
                                        color: "#52526F",
                                        icon: _unref(mdiShareVariantOutline),
                                        onClick: _withModifiers(($event: any) => (
                        openShareModal(
                          healthUnit.name,
                          _unref(AuthorizationResourcesAndSubjects).HealthUnit,
                          healthUnit.id,
                          company.id,
                          [company.name, healthUnit.name]
                        )
                      ), ["stop"])
                                      }), null, 16, ["icon", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(ArrowIcon, {
                                class: _normalizeClass(showHealthUnits.value[healthUnit.id] ? 'rotate-180' : ''),
                                color: "#000"
                              }, null, 8, ["class"])
                            ]),
                            (showHealthUnits.value[healthUnit.id])
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sortedSchedules(healthUnit.schedules), (schedule) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: schedule.id
                                  }, [
                                    (canReadSchedule(schedule.id))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          onClick: _withModifiers(($event: any) => (toggleShifts(schedule.id)), ["stop"]),
                                          class: "card2 bg-gray-50"
                                        }, [
                                          _createElementVNode("div", _hoisted_15, [
                                            _hoisted_16,
                                            _createElementVNode("span", _hoisted_17, [
                                              (expiredScheduleSet.value.has(schedule.id))
                                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                    key: 0,
                                                    text: "Escala expirada",
                                                    location: "top"
                                                  }, {
                                                    activator: _withCtx(({ props: tooltipProps }) => [
                                                      _createVNode(LabelBadge, _mergeProps(tooltipProps, {
                                                        label: "",
                                                        color: "orange",
                                                        size: "small",
                                                        "data-testid": "expired-schedule-badge"
                                                      }), null, 16)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              _createTextVNode(" " + _toDisplayString(schedule.name.toLocaleLowerCase()), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_18, [
                                              _createElementVNode("span", null, _toDisplayString(getTimezoneDetails(schedule.timezone)?.title), 1),
                                              _createElementVNode("span", null, "(" + _toDisplayString(getTimezoneDetails(schedule.timezone)?.subtitle) + ")", 1)
                                            ])
                                          ]),
                                          _createElementVNode("span", _hoisted_19, [
                                            (policyAlertSet.value.has(schedule.id))
                                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                  key: 0,
                                                  text: "Existe(m) política(s) sem vigência",
                                                  location: "top"
                                                }, {
                                                  activator: _withCtx(({ props: tooltipProps }) => [
                                                    _createVNode(LabelBadge, _mergeProps(tooltipProps, {
                                                      label: "",
                                                      color: "red",
                                                      size: "small",
                                                      "data-testid": "policy-alert-badge"
                                                    }), null, 16)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (_unref(canReadSharingModal))
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 1,
                                                  class: "share-icon hover:cursor-pointer",
                                                  color: "#52526F",
                                                  icon: _unref(mdiShareVariantOutline),
                                                  onClick: _withModifiers(($event: any) => (
                          openShareModal(
                            schedule.name,
                            _unref(AuthorizationResourcesAndSubjects).Schedule,
                            schedule.id,
                            company.id,
                            [company.name, healthUnit.name, schedule.name]
                          )
                        ), ["stop"])
                                                }, null, 8, ["icon", "onClick"]))
                                              : _createCommentVNode("", true),
                                            (_unref(canEditSchedule))
                                              ? (_openBlock(), _createBlock(EditIcon, {
                                                  key: 2,
                                                  onClick: _withModifiers(($event: any) => (
                          handleUpdate({
                            id: schedule.id,
                            name: schedule.name,
                            healthUnitName: healthUnit.name,
                            companyName: company.name,
                            companyId: company.id,
                            endDate: schedule.endDate ?? null
                          })
                        ), ["stop"]),
                                                  class: "cursor-pointer"
                                                }, null, 8, ["onClick"]))
                                              : _createCommentVNode("", true),
                                            (_unref(canDeactivateSchedule))
                                              ? (_openBlock(), _createBlock(DeleteIcon, {
                                                  key: 3,
                                                  onClick: _withModifiers(($event: any) => (handleRemove(schedule.id, schedule.name)), ["stop"]),
                                                  class: "cursor-pointer"
                                                }, null, 8, ["onClick"]))
                                              : _createCommentVNode("", true),
                                            (schedule.shifts.length > 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                  _createVNode(ArrowIcon, {
                                                    class: _normalizeClass([showShifts.value[schedule.id] ? 'rotate-180' : '', "cursor-pointer"]),
                                                    color: "#52526F",
                                                    onClick: _withModifiers(($event: any) => (toggleShifts(schedule.id)), ["stop"])
                                                  }, null, 8, ["class", "onClick"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (showShifts.value[schedule.id])
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(schedule.shifts, (shift) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: shift.id,
                                                  class: "card2 bg-gray-100",
                                                  onClick: _withModifiers(($event: any) => (togglePositions(shift.id)), ["stop"])
                                                }, [
                                                  _createElementVNode("div", _hoisted_22, [
                                                    _hoisted_23,
                                                    _createElementVNode("span", _hoisted_24, _toDisplayString(shift.name.toLocaleLowerCase()), 1)
                                                  ]),
                                                  _createElementVNode("span", _hoisted_25, [
                                                    (shift.positions.length > 0)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                          _createVNode(ArrowIcon, {
                                                            class: _normalizeClass([showPositions.value[shift.id] ? 'rotate-180' : '', "cursor-pointer"]),
                                                            color: "#52526F",
                                                            onClick: _withModifiers(($event: any) => (togglePositions(shift.id)), ["stop"])
                                                          }, null, 8, ["class", "onClick"])
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (showPositions.value[shift.id])
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(shift.positions, (position) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: position.id,
                                                          class: "card2 bg-white"
                                                        }, [
                                                          _createElementVNode("div", _hoisted_27, [
                                                            _hoisted_28,
                                                            _createElementVNode("span", _hoisted_29, _toDisplayString(position.name.toLocaleLowerCase()), 1)
                                                          ]),
                                                          _createElementVNode("span", _hoisted_30, [
                                                            _createVNode(_component_v_tooltip, {
                                                              text: "Políticas",
                                                              location: "top"
                                                            }, {
                                                              activator: _withCtx(({ props: tooltipProps }) => [
                                                                (_unref(canReadSchedulePolicies))
                                                                  ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, tooltipProps, {
                                                                      "data-testid": "position-policies-button",
                                                                      icon: _unref(mdiClipboardTextOutline),
                                                                      onClick: _withModifiers(($event: any) => (
                                      showPositionPolicies(company.id, position.id, position.name)
                                    ), ["stop"])
                                                                    }), null, 16, ["icon", "onClick"]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            (_unref(canEditSchedulePosition))
                                                              ? (_openBlock(), _createBlock(EditIcon, {
                                                                  key: 0,
                                                                  onClick: _withModifiers(($event: any) => (handleUpdatePosition(position.id, schedule.id)), ["stop"]),
                                                                  class: "cursor-pointer"
                                                                }, null, 8, ["onClick"]))
                                                              : _createCommentVNode("", true),
                                                            (_unref(canDeactivateSchedulePosition))
                                                              ? (_openBlock(), _createBlock(DeleteIcon, {
                                                                  key: 1,
                                                                  onClick: _withModifiers(($event: any) => (handleRemovePosition(position.id)), ["stop"]),
                                                                  class: "cursor-pointer"
                                                                }, null, 8, ["onClick"]))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ]))
                                                      }), 128))
                                                    : _createCommentVNode("", true)
                                                ], 8, _hoisted_21))
                                              }), 128))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_14))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_9))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (isSearchActive.value && filteredSchedules.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Nenhum resultado encontrado para \"" + _toDisplayString(searchTerm.value) + "\" ", 1))
            : _createCommentVNode("", true)
        ], 64)),
    (healthUnitSelected.value)
      ? (_openBlock(), _createBlock(SortScalesModal, {
          key: 2,
          modalActive: showModalSortScales.value,
          unitData: healthUnitSelected.value,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showModalSortScales.value = false))
        }, null, 8, ["modalActive", "unitData"]))
      : _createCommentVNode("", true),
    (policiesTarget.value)
      ? (_openBlock(), _createBlock(ResourcePoliciesModal, {
          key: 3,
          resource: policiesTarget.value
        }, null, 8, ["resource"]))
      : _createCommentVNode("", true),
    _createVNode(ShareModal),
    (toggleScheduleVisibilityModal.value)
      ? (_openBlock(), _createBlock(HealthUnitScheduleVisibilityModal, {
          key: 4,
          healthUnit: healthUnitToUpdate.value,
          modalStateProp: toggleScheduleVisibilityModal.value,
          onClose: closeScheduleVisibilityModal
        }, null, 8, ["healthUnit", "modalStateProp"]))
      : _createCommentVNode("", true)
  ]))
}
}

})